export const zh = {
  status: '物流状态',
  status1: '待发货',
  status2: '已发货',
  status3: '已取消',
  status4: '待打单',
  status5: '已退款',
  status6: '门店发货',
  status7: '运输中',
  status8: '派送中',
  status9: '已送达',
  status10: '运输异常',
  status99: '草稿',
  partialDelivered: '部分送达（{delivered}/{total}）'
}

export const en = {
  status: 'Shipping Status',
  status1: 'Ready to Ship',
  status2: 'Shipped',
  status3: 'Cancelled',
  status4: 'Ready to Print',
  status5: 'Refunded',
  status6: 'Store Shipment',
  status7: 'In Transit',
  status8: 'Out for Delivery',
  status9: 'Delivered',
  status10: 'Shipping Exception',
  status99: 'Draft',
  partialDelivered: 'Partially delivered ({delivered}/{total})'
}
